<template>
  <div class="Flex Flex--d-c PageWrapper" id="PageWrapper" ref="PageWrapper">
    <div class="FlexItem childView">
      <div class="FlexItem">
        <div class="containerCls">
          <audio id="audioRef" autoplay src="../assets/empty.mp3"></audio>
          <audio id="AutoplayRef" autoplay src=""></audio>
          <div
            :class="{ MessageContainer: true, clearMarginCls: !isInputShow }"
          >
            <TopView
              :durationNum="globalDuration"
              @on-set-duration="setGlobalDuration"
              @on-ask="onPoke"
              :questionTips="questionTips"
              :guideTips="guideTips"
            />
            <div
              :class="['PullToRefresh', device == 'ios' ? 'iosMinHeight' : '']"
            >
              <div
                :class="{
                  'PullToRefresh-inner': true,
                  tourPaddingBottom: isTourShow,
                  inputPaddingBottom: isInputShow,
                  audioPaddingBottom: isAudioBarShow,
                }"
              >
                <div class="PullToRefresh-content">
                  <div
                    class="contentBox chatting-content"
                    ref="chatMain"
                    id="chatMain"
                  >
                    <slot></slot>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <RelateReplies
            :list="toastList"
            :currList="toastCurrList"
            :show="!!toastList.length && isToast && !isTourShow && !isAudioShow"
            @on-ask="onRateAsk"
            v-if="!isOpenChat"
          />

          <!--                        <transition name="fadeInput">-->
          <!--                            <div :class="['questionBox', 'questionPadding', 'questionRadius','padByDevice']" id="tourBox" v-show="isTourShow">-->
          <!--                                <SelectTags :list="tagsList"/>-->
          <!--                                <SelectTour :list="selectList" :show="false" @on-ask="onSelectToast" />-->
          <!--                            </div>-->
          <!--                        </transition>-->

          <transition name="fadeInUp">
            <div
              v-if="isAudioBarShow === 'audio'"
              :class="[isInputShow ? 'audioWrapper' : 'bottomAudioWrapper']"
            >
              <audio-bar />
            </div>
            <div
              v-else-if="isAudioBarShow === 'ximalaya'"
              :class="[isInputShow ? 'audioWrapper' : 'bottomAudioWrapper']"
            >
              <ximalaya-audio-bar />
            </div>
          </transition>

          <transition name="fadeInput">
            <!-- isInputShow显示输入框  -->
            <!-- isVoiceInput 表示输入方式为文字输入 -->
            <div
              :class="[
                'questionBox',
                'questionPadding',
                'questionRadius',
                'padByDevice',
              ]"
              id="questionBox"
              v-show="isInputShow"
            >
              <!-- isOpenChat 聊天功能 -->
              <QuickReplies
                :list="noticeList"
                :show="!!toastList.length && isToast"
                @on-ask="onQuickAsk"
                v-if="
                  !isOpenChat && !isTourShow && !isAudioShow && !isToSpeakIng
                "
              />
              <!-- isTourShow旅游场景 -->
              <QuickReplies
                :list="selectTourList"
                :show="!isTourShow"
                @on-ask="onQuickAsk"
                v-if="isTourShow && !isToSpeakIng"
                color="scrollTourTags"
              />
              <!-- isAudioShow 音乐播放场景 -->
              <QuickReplies
                :list="audioSelectData"
                :show="!isAudioShow"
                @on-ask="onQuickAsk"
                v-if="isAudioShow && !isToSpeakIng"
                color="scrollTourTags"
              />
              <!-- 输入框 -->
              <div :class="['ComposerPC', 'isCompact']" v-if="!isVoiceInput">
                <!--修改input的限制字数-->
                <input
                  id="inputValue"
                  ref="searchInput"
                  type="text"
                  placeholder="有什么想说的在这里说哦~"
                  v-model.trim="inputValue"
                  class="inputCls"
                  v-on:input="onRate"
                  maxlength="1024"
                  @blur="onBlur"
                  :disabled="!homeChat.length || chatLoading"
                />
                <div class="button" v-if="!inputBtnInit">
                  <span @click="onAsk">发送</span>
                </div>
                <!-- 切换输入的方式 -->
                <div class="button" v-else>
                  <span @click="onChangeInputType(true)">
                    <img
                      src="../assets/img/voiceBtn.png"
                      alt="切换页面输入方式"
                    />
                  </span>
                </div>
              </div>
              <!-- 语音 -->
              <div v-else>
                <VoiceInputView @onChangeInputType="onChangeInputType">
                </VoiceInputView>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import COVERAPP from "@/utils/COVERAPP";
import { parseData,popConfirm } from "@/utils/utils";
import { TopView, QuickReplies, RelateReplies } from "./View/index";
import SelectTags from "./Use/tags";
import SelectTour from "./Use/select-tour";
import AudioBar from "./Use/audio-bar";
import XimalayaAudioBar from "./Use/ximalaya-audio-bar";
import VoiceInputView from "./Use/VoiceInputView";
import Recorder from "js-audio-recorder";
export default {
  name: "PageWrapper",
  components: {
    TopView,
    QuickReplies,
    RelateReplies,
    SelectTags,
    SelectTour,
    AudioBar,
    XimalayaAudioBar,
    VoiceInputView,
  },
  props: {},
  data() {
    return {
      inputValue: "",
      isToast: false,
      toastCurrList: [],
      inputBtnInit: true, //输入按钮的初始状态
    };
  },
  mounted() {
    this.$nextTick(() => {
    
      // 监听输入框软键盘回车键，点击回车键，软键盘收起
      this.$refs.searchInput.addEventListener("keyup", (e) => {
        if (e.keyCode == 13) {
          this.$refs.searchInput.blur();
          this.onAsk();
        }
      });
    });
  },
  watch: {},
  computed: {
    ...mapState([
      "toastList",
      "noticeList",
      "globalDuration",
      "device",
      "isOpenChat",
      "readNewsId",
      "isInputShow",
      "questionTips",
      "guideTips",
      "isTourShow",
      "selectList",
      "tagsList",
      "audioSelectData",
      "isAudioShow",
      "isAudioBarShow",
      "chatLoading",
      "homeChat",
      "isToastShow",
      "OpenChatID",
      "feedbackType",
      "feedbackDirection",
      "isVoiceInput",
      "isToSpeakIng",
      "isEnterFirst",
      "AutoplayPlayer",
      "isPermitUseMicrophone",
      "MicrophoneErrorData",
    ]),
    ...mapState("audio", ["fPlayer", "xPlayer", "audioCurrentIndex"]),
    selectTourList() {
      const { selectList, tourSelectType } = this.$store.state;
      // console.info('tourSelectType',tourSelectType, selectList)
      return tourSelectType
        ? selectList.filter((it) => {
            return it.value == tourSelectType;
          })[0].children
        : [];
    },
  },
  methods: {
    ...mapMutations([
      "contactDisData",
      "setHomeData",
      "setToastList",
      "setLinkSrc",
      "setGlobalDuration",
      "setChatLoading",
      "setClearTimer",
      "setInputShow",
      "setMaskShowStatus",
      "setTourSelectData",
      "setToastShow",
      "setToastContent",
      "setAudioBarShow",
      "setVoiceInput",
      "setXFAutoplay",
      "setEnterFirst",
      "setAutoplayPlayer",
      "setAutoplayIng",
    ]),
    ...mapMutations("audio", [
      "setAudioList",
      "setAudioCurrentIndex",
      "setAudioCurrentTime",
      "setDuration",
      "setXPlayer",
      "setFPlayer",
    ]),
    ...mapActions([
      "fetchRelate",
      "fetchHome",
      "fetchNotice",
      "discussNews",
      "queryPoke",
      "getTourSelectData",
      "queryTourism",
      "queryAudioSearch",
      "getFakeUser",
      "feedbackDataAsync",
      "setMaskDataAsync",
    ]),
   
    onAsk() {
      let that = this;
      this.isToast = false;
      this.service.pageScrollTo();
      this.setToastList([]);
      // let inputValue = this.inputValue.replace(/(\r\n|\n|\r)/gm, " ")
      if (this.inputValue !== "") {
        this.onRequest(this.inputValue, this.inputValue, false, "input");
        this.inputBtnInit = true;
      } else {
        return;
      }
    },

    onRequest(name, value, hasClearTimer, type) {
      let that = this;
      this.setChatLoading(true);
      this.setGlobalDuration(0);
      this.setClearTimer(true);
      that.contactDisData([{ content: { right: true, tips: name } }]);
      that.inputValue = "";
      // value = value.replace(/(\r\n|\n|\r)/gm, " ")
      if (this.isOpenChat) {
        switch (this.OpenChatID) {
          case 0:
            {
              that
                .discussNews({
                  payload: { question: value, newsId: this.readNewsId },
                })
                .then((res) => {
                  if (res.length) {
                    that.setChatLoading(false);
                  }
                  cio.track(7, "click", "send_msg", { msg: value });

                  setTimeout(() => {
                    that.service.pageScrollTo();
                  }, 100);
                });
            }
            break;
          case 1:
            {
              that
                .feedbackDataAsync({
                  payload: {
                    content: value,
                    feedbackDirection: that.feedbackDirection,
                    feedbackType: that.feedbackType,
                  },
                })
                .then((res) => {
                  if (res.length) {
                    that.setChatLoading(false);
                  }
                  cio.track(7, "click", "send_msg", { msg: value });

                  setTimeout(() => {
                    that.service.pageScrollTo();
                  }, 100);
                });
            }
            break;
        }
      } else if (this.isAudioShow && type === "button") {
        // that.setAudioList([])
        that.setAudioCurrentIndex(-1);
        setTimeout(() => {
          // this.xPlayer && this.xPlayer.pause()
          that.setAudioCurrentTime(0);
          that.setDuration(0);
          that
            .fetchHome({ payload: { question: value, hasClearTimer } })
            .then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              cio.track(7, "click", "send_msg", { msg: value });
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 100);
            });
        }, 1000);
      } else if (this.isAudioShow && type === "input") {
        // that.setAudioList([])
        that.setAudioBarShow(false);
        that.setAudioCurrentIndex(-1);
        setTimeout(() => {
          that.setAudioCurrentTime(0);
          that.setDuration(0);
          that
            .fetchHome({ payload: { question: value, hasClearTimer } })
            .then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              cio.track(7, "click", "send_msg", { msg: value });
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 100);
            });
        }, 1000);
      } else {
        that
          .fetchHome({ payload: { question: value, hasClearTimer } })
          .then((res) => {
            if (res.length) {
              that.setChatLoading(false);
            }
            cio.track(7, "click", "send_msg", { msg: value });
            setTimeout(() => {
              that.service.pageScrollTo();
            }, 100);
          });
      }
    },

    onRateAsk(value) {
      this.isToast = false;
      this.setToastList([]);
      cio.track(4, "click", "foot_shortcut", { shortcutName: value });
      // cio.track(5,'click', "click_scene",{sceneName:value});
      this.onRequest(value, value, false);
      this.inputBtnInit = true;
    },

    onRate() {
      let that = this;
      // 输入文字，语音切换按钮替换为发送按钮
      if (this.inputValue.length > 0) {
        that.inputBtnInit = false;
      } else {
        that.inputBtnInit = true;
      }
      if (this.inputValue !== "") {
        that.setClearTimer(true);
        that.isToast = true;
        that
          .fetchRelate({ payload: { question: this.inputValue } })
          .then((res) => {
            that.toastCurrList = parseData(res, this.inputValue);
          });
      } else if (this.isAudioShow) {
        that.setClearTimer(true);
        that.toastCurrList = [];
        that.isToast = false;
        that.setToastList([]);
      } else {
        that.setClearTimer(false);
        that.toastCurrList = [];
        that.isToast = false;
        that.setToastList([]);
      }
    },
    onBlur() {
      // console.info("onBlur");
      let that = this;
      setTimeout(() => {
        that.setMaskShowStatus(false);
      }, 0);
    },

    onQuickAsk(name, value) {
      //加载完毕才能点击快速访问按钮

      if (!this.chatLoading && this.homeChat.length) {
        this.onRequest(name, value, true, "button");
      }
    },

    onPoke(name, value) {
      let that = this;
      this.setChatLoading(true);
      this.setGlobalDuration(0);
      this.setClearTimer(true);
      that.contactDisData([{ content: { right: true, tips: name } }]);

      that.queryPoke().then((res) => {
        if (res.length) {
          that.setChatLoading(false);
        }
        setTimeout(() => {
          that.service.pageScrollTo();
        }, 100);
      });
    },

    onSelectToast(name, value, id, toastType, children, selectType) {
      let that = this;
      this.setToastShow(true);
      this.setToastContent({
        toastType: toastType,
        selectType,
        list: { name: name, content: children },
      });
      this.setTourSelectData(children);
    },

    // 改变用户的输入方式，文字为音频
    onChangeInputType(value) {
      //  权限打开了
      if (this.isPermitUseMicrophone) {
        //  页面以来就打开了
        this.setVoiceInput(value);
        if (this.isEnterFirst) {
          //进入页面的第一次点击
          //开启自动播放播放器的
          this.setAutoplayPlayer(document.getElementById("AutoplayRef"));
          this.AutoplayPlayer.addEventListener("ended", () => {
            // console.log("语音播放结束");
            this.setAutoplayIng(false);
          });
          this.setXFAutoplay(true);
          this.setEnterFirst(false);
        }
      } else {
        if (
          COVERAPP.Attribute.isIOS() &&
          COVERAPP.Attribute.isWeixin() &&
          this.MicrophoneErrorData === "Error"
        ) {
          //  如果是ios 的微信中打开  没有定义getUserMedia 引导下载app
          if (this.device === "ios") {
                        popConfirm(
                          "请前往下载APP",
                          () => {
                            window.open("https://apps.apple.com/cn/app/id1028293650");
                          },
                          () => {}
                        );
                      } else {
                        popConfirm(
                          "请前往下载APP",
                          () => {
                            window.open(
                              "https://a.app.qq.com/o/simple.jsp?pkgname=cn.thecover.www.covermedia"
                            );
                          },
                          () => {}
                        );
                      }
        } else {
          let html = `<div class="NotAllowedError">
            <div class="title">麦克风权限未开启</div>
            `;
          let endhtml = ``;
          if (COVERAPP.Attribute.isApp()) {
            // 是在app中
            if (
              this.MicrophoneErrorData === "Error" &&
              COVERAPP.Attribute.isIOS()
            ) {
              //表示iso系统版本过低
              endhtml = `<div class='des'>你手机系统版本过低，不支持语音录入功能，请更新最新系统</div>
                          </div>`;
            } else if (
              this.MicrophoneErrorData === "Error" &&
              COVERAPP.Attribute.isAndroid()
            ) {
              //表示Android系统版本过低
              endhtml = `<div class='des'>你手机系统版本过低，不支持语音录入功能，请更新最新系统</div>
                          </div>`;
            } else if (
              this.MicrophoneErrorData === "NotAllowedError" ||
              this.MicrophoneErrorData === "PermissionDeniedError"
            ) {
              // app语音权限拒绝
              if (COVERAPP.Attribute.isIOS()) {
                //  ios
                endhtml = `<div class='des'>麦克风权限未开启，请进入系统【设置】>【隐私】>【麦克风】中打开开关，开启麦克风功能之后刷新页面进行访问</div>
                          </div>`;
              } else {
                endhtml = `<div class='des'>麦克风权限未开启，请进入系统【设置】>【应用管理】>【麦克风】中打开开关，开启麦克风功能之后刷新页面进行访问</div>
                                    </div>`;
              }
            }
          } else {
            // 浏览器里面
            if (
              this.MicrophoneErrorData === "NotAllowedError" ||
              this.MicrophoneErrorData === "PermissionDeniedError"||
               this.MicrophoneErrorData === "NotReadableError"||
                this.MicrophoneErrorData === "NotFoundError"
            ) {
              endhtml = `<div class='des'>麦克风权限未开启，请进入系统【设置】>【隐私设置和安全性】>【网站】>【麦克风】中打开开关，开启麦克风功能之后刷新页面进行访问</div>
                                  </div>`;
            } else if (this.MicrophoneErrorData === "Error") {
              endhtml = `<div class='des'>浏览器不能够获取用户麦克风权限</div>
                                  </div>`;
            }
          }

          html = html + endhtml;
          this.setMaskDataAsync({ type: 11, text: html });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.PageWrapper {
  overflow: hidden;
  width: 100%;
  height: 100%;
  /*margin: 0 auto;*/
  /*height: 9rem;*/
  /*background: #fff;*/
  /*position: absolute;*/
  /*bottom: 0;*/
  /*border-radius: .8rem 0 0 0;*/

  /*position: fixed;*/
  /*bottom: 0;*/
  /*top: 0;*/
  /*left: 0;*/
  /*right: 0;*/

  .fadeInput-enter-active,
  .fadeInput-leave-active {
    transition: opacity 0.5s;
  }

  .fadeInput-enter,
  .fadeInput-leave-to {
    opacity: 0;
  }

  .containerCls {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 100%;
  }

  .childView {
    display: flex;
  }

  .contentBox {
    overflow-y: scroll;
  }

  .tourPaddingBottom {
    padding-bottom: 3rem;
  }
  .inputPaddingBottom {
    padding-bottom: 4rem !important;
  }
  .audioPaddingBottom {
    padding-bottom: 3rem;
  }

  .PullToRefresh-inner {
    overflow: hidden;
    /*min-height:100%;*/
  }

  .PullToRefresh {
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    /*padding-bottom: 2rem;*/
  }

  .iosMinHeight {
    min-height: 8rem;
  }

  .MessageContainer {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex: 1;
    flex: 1;
    min-height: 0;
    /*margin-bottom: 1.3rem;*/
  }

  .questionBox {
    /*height: 3.79rem;*/
    box-sizing: border-box;
    padding: 0.43rem;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 102;

    .ComposerPC {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: end;
      justify-content: space-between;
      padding: 0.1rem 0;
      margin-top: 0.22rem;
      align-items: center;
    }

    .inputCls {
      width: 7.55rem;
      height: 1.17rem;
      padding: 0 0.43rem;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: none;
      font-size: 0.37rem;
      background: #fffafa;
      border-radius: 0.6rem;
      border: 0.03rem solid #fff1f1;
      -webkit-appearance: none;
      line-height: 1.17rem;
    }

    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      // .sendImg {
      //   width: 1.17rem;
      //   height: 1.17rem;
      // }
      align-items: center;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      background-color: #e65757;
      font-size: 0.36rem;
      color: #fff;
      font-weight: 600;
    }

    .disable {
      background: #f0f2f5;
    }
  }
  .audioWrapper {
    width: 8.72rem;
    height: 2.48rem;
    background: #ffffff;
    box-shadow: 0rem 0.11rem 0.53rem 0rem rgba(63, 142, 247, 0.13);
    border-radius: 0.16rem;
    /*position: fixed;*/
    position: absolute;
    bottom: 2.5rem;
    left: calc(50% - 4.36rem);
    z-index: 101;
  }
  .bottomAudioWrapper {
    width: 8.72rem;
    height: 2rem;
    background: #ffffff;
    box-shadow: 0rem 0.11rem 0.53rem 0rem rgba(63, 142, 247, 0.13);
    border-radius: 0.16rem;
    /*position: fixed;*/
    position: absolute;
    bottom: 0;
    left: calc(50% - 4.36rem);
    z-index: 101;
  }
}
</style>
